<nav #navbar class="navbar navbar-default navbar-fixed-top navbar-scroll" [class.v2]="!router.isActive('/carte',false)"
    role="navigation">
        <div class="navbar-header page-scroll">
            <button type="button" class="navbar-toggle collapsed" (click)="isCollapsed = !isCollapsed"
                aria-expanded="false">
                <span class="sr-only">Toggle navigation</span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
            </button>
        </div>
        <div id="navbar" class="navbar-collapse collapse" [collapse]="isCollapsed">
            <div class="nav1">
                <ul class="nav navbar-nav">
                    <li [class.active]="router.isActive('/',true)">
                        <a class="page-scroll" [routerLink]="'/'">Accueil</a>
                    </li>
                    <li [class.active]="router.isActive('/carte',false)">
                        <a [routerLink]="'/carte'" class="cursor-pointer page-scroll">Commander</a>
                    </li>
                    <li [class.active]="router.isActive('/restaurant',false)">
                        <a class="page-scroll" [routerLink]="'/restaurant'">Le Restaurant</a>
                    </li>
                    <!-- <li class="btn-group" dropdown>
                        <button id="button-basic" dropdownToggle type="button" class="dropdown-toggle"
                            aria-controls="dropdown-basic">
                            Le Restaurant
                            <span class="caret"></span>
                        </button>
                        <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu" role="menu"
                            aria-labelledby="button-basic">
                            <li>
                                <a [routerLink]="'/restaurant'">Infos générales</a>
                            </li>
                            <li>
                                <a [routerLink]="'/commandes'">Recrutement </a>
                            </li>
                            <li>
                                <a [routerLink]="'/commandes'">Franchise </a>
                            </li>
                        </ul>
                    </li> -->
                </ul>
            </div>
            <div class="logo">
                <a class="page-scroll" [routerLink]="'/'" [class.login]="log">
                    <img src="assets/images/logos/logo1.png" alt="logo">
                </a>
            </div>
            <div class="nav2">
                <ul class="nav navbar-nav">
                    <li [class.active]="router.isActive('/contact',false)">
                        <a class="page-scroll" [routerLink]="'/contact'">Contact</a>
                    </li>
                    <li *ngIf="!log">
                        <a routerLink="/compte/connexion" class="login">S'identifier / S'INSCRIRE</a>
                    </li>
                    <!-- <li *ngIf="!log">
                        <a routerLink="/compte/inscription" class="login">S'INSCRIRE</a>
                    </li> -->
                    <li *ngIf="log" [class.active]="router.isActive('/commandes',false)">
                        <a [routerLink]="'/commandes'">Commandes</a>
                    </li>
                    <li class="btn-group" dropdown *ngIf="log">
                        <button id="button-basic" dropdownToggle type="button" class="dropdown-toggle"
                            aria-controls="dropdown-basic">
                            Mon compte
                            <span class="caret"></span>
                        </button>
                        <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu" role="menu"
                            aria-labelledby="button-basic">
                            <li>
                                <a [routerLink]="'/profil'">Profil</a>
                            </li>
                            <li>
                                <a [routerLink]="'/commandes'">Commandes</a>
                            </li>
                            <li role="separator" class="divider"></li>
                            <li>
                                <a (click)="logout()">Déconnexion</a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <!-- <ul class="nav navbar-nav navbar-right">
                
                <li class="logo">
                    
                </li>
            </ul> -->
        </div>
    <!-- </div> -->
    <!-- <div class="to">
        <a href="https://burgerbynight16.fr/" target="_blank" class="pulse-button">Commander nos Burgers</a>
    </div> -->
</nav>